import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Helmet } from 'react-helmet'
import '../../styles/toggle.pcss'
import {
  changeLayoutWidth,
  changeTheme,
  changeFrontPage,
  LAYOUT_WIDTH_FULL,
  LAYOUT_WIDTH_NORMAL,
  LAYOUT_WIDTH_WIDE,
} from '../userActions'
import { selectUserFrontPage, selectUserLayoutWidth, selectUserPrimaryTheme } from '../../selectors/userSelector'
import { config } from '../../../config/config'

const GeneralSettingsView = () => {
  const dispatch = useDispatch()

  const selectedTheme = useSelector(selectUserPrimaryTheme)
  const selectedLayoutWidth = useSelector(selectUserLayoutWidth)
  const selectedFrontPage = useSelector(selectUserFrontPage)

  const handleFrontPageChange = (e) => {
    dispatch(changeFrontPage(e.target.value))
  }

  const handleThemeChange = (e) => {
    dispatch(changeTheme(e.target.value))
  }

  const handleLayoutWidthChange = (e) => {
    dispatch(changeLayoutWidth(e.target.value))
  }

  return (
    <div>
      <Helmet title='Yleiset' />

      <section className='content padded'>
        <div className='personal'>
          <div className='container'>
            <h3>Aloitussivu</h3>
            <p>Tällä asetuksella voit vaihtaa sivuston aloitusnäkymän</p>
            <label>
              <input
                type='radio'
                name='front-page'
                value='/'
                checked={ selectedFrontPage === '/' }
                onChange={ handleFrontPageChange }
              /> Etusivu
            </label>
            <br />
            <label>
              <input
                type='radio'
                name='front-page'
                value='/omat'
                checked={ selectedFrontPage === '/omat' }
                onChange={ handleFrontPageChange }
              /> Omat aiheet
            </label>
            <br />
            <label>
              <input
                type='radio'
                name='front-page'
                value='/uusimmat'
                checked={ selectedFrontPage === '/uusimmat' }
                onChange={ handleFrontPageChange }
              /> Uusimmat
            </label>
            <br />
            <label>
              <input
                type='radio'
                name='front-page'
                value='/luetuimmat'
                checked={ selectedFrontPage === '/luetuimmat' }
                onChange={ handleFrontPageChange }
              /> Luetuimmat
            </label>
            <br />
            <label>
              <input
                type='radio'
                name='front-page'
                value='/aanestetyimmat'
                checked={ selectedFrontPage === '/aanestetyimmat' }
                onChange={ handleFrontPageChange }
              /> Äänestetyimmät
            </label>

            <hr />

            <h3>Valitse teema</h3>
            <p>Tällä asetuksella voit muuttaa, miltä Ampparit.com näyttää sinun laitteellasi</p>
            <label>
              <input
                type='radio'
                name='theme'
                value='classic'
                checked={ selectedTheme === 'classic' }
                onChange={ handleThemeChange }
              /> Classic
            </label>
            <br />
            <label>
              <input
                type='radio'
                name='theme'
                value='default'
                checked={ selectedTheme === 'default' }
                onChange={ handleThemeChange }
              /> Vaalea
            </label>
            <br />
            <label>
              <input
                type='radio'
                name='theme'
                value='night'
                checked={ selectedTheme === 'night' }
                onChange={ handleThemeChange }
              /> Tumma
            </label>
            <br />
            <label>
              <input
                type='radio'
                name='theme'
                value='matrix'
                checked={ selectedTheme === 'matrix' }
                onChange={ handleThemeChange }
              /> Tumma & vihreä
            </label>

            <hr />

            <h3>Sivun leveys</h3>
            <p>Tällä asetuksella voit muuttaa sivupohjan maksimileveyttä</p>
            <label>
              <input
                type='radio'
                name='page-width'
                value={ LAYOUT_WIDTH_NORMAL }
                checked={ selectedLayoutWidth === LAYOUT_WIDTH_NORMAL }
                onChange={ handleLayoutWidthChange }
              /> Oletus - 1200px
            </label>
            <br />
            <label>
              <input
                type='radio'
                name='page-width'
                value={ LAYOUT_WIDTH_WIDE }
                checked={ selectedLayoutWidth === LAYOUT_WIDTH_WIDE }
                onChange={ handleLayoutWidthChange }
              /> Leveä - 1600px
            </label>
            <br />
            <label>
              <input
                type='radio'
                name='page-width'
                value={ LAYOUT_WIDTH_FULL }
                checked={ selectedLayoutWidth === LAYOUT_WIDTH_FULL }
                onChange={ handleLayoutWidthChange }
              /> Täysleveä
            </label>

            <hr />

            <div className='forgotten-password'>
              <h3>Vaihda salasana</h3>
              <a className='button button_large' href={ `${config.almaTunnusConfig.selfService}/unohtunut-salasana?clientId=${config.almaTunnusConfig.clientID}` } target='_blank' rel='noopener noreferrer'>
                Vaihda salasana täällä
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

GeneralSettingsView.propTypes = {}

export default GeneralSettingsView
